import './index.scss'

document.querySelector('.google_maps').innerHTML = document.querySelector('.shops_wrapper').dataset.frame
document.querySelector('.shops_wrapper').classList.add('active')

document.querySelectorAll('.shops_wrapper').forEach(item => {
    item.addEventListener('click', () => {
        document.querySelectorAll('.shops_wrapper').forEach(item => item.classList.remove('active'))
        document.querySelector('.google_maps').innerHTML = item.dataset.frame
        item.classList.add('active')
    })
})